<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<div class="modal-card-head">
				<p class="modal-card-title">Error</p>
			</div>
			<div class="modal-card-body">
				<p v-for="(error, index) in errors" :key="index">
					{{ error.replace(/^./, error[0].toUpperCase()) }}
				</p>
				<p v-if="errors.length < 1">Something went wrong</p>
			</div>
			<div class="modal-card-foot">
				<div class="button is-warning" @click="closeModal">Close</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		errors: {
			required: true,
			type: Array
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		}
	}
};
</script>

<style lang="scss"></style>
